import cls from './../Info/Info.module.scss'
import { useTranslation } from "react-i18next";

function Education() {
    const { t } = useTranslation()
    return (
        <section className={cls.info}>
            <div className="hover-lift" style={{ padding: '20px', background: 'rgba(255,255,255,0.3)', borderRadius: '10px' }}>
                <p>{t('paragraph 5')}</p>
                <p>{t('paragraph 6')}</p>
                <p>{t('paragraph 7')}</p>
            </div>
        </section>
    )
}

export default Education
